module.exports = "/build/images/icons-public.6782aa27.svg";